import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import ServicesItemBlockData from 'app/Models/Content/ServicesItemBlockData';
import ServicesItemsBlockData from 'app/Models/Content/ServicesItemsBlockData';
import React from 'react';
import {Container} from 'reactstrap';
import SwiperCore, {Pagination} from 'swiper';
import 'swiper/components/pagination/pagination.scss';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper.scss';
import ServicesItemBlock from './ServicesItemBlock';
import {getImageProps} from 'app/utilities/ImageProps';

SwiperCore.use([Pagination]);

const ServicesItemsBlock = ({data, context}: ComponentProps<ServicesItemsBlockData>) => {
  const {fadeClass, ref} = useFadeIn();

  return (
    <div ref={ref} className='ServicesItemsBlock'>
      <h2 className='ServicesItemsBlock__title'>{data.title.value}</h2>

      <p className='ServicesItemsBlock__subtitle'>{data.subtitle.value}</p>

      {/* mobile */}
      <Swiper
        pagination={{clickable: true}}
        spaceBetween={11}
        slidesPerView={1.2}
        centeredSlides
        className='ServicesItemsBlock__swiper d-sm-none'>
        {data.items.expandedValue.map((item: ServicesItemBlockData, i) => (
          <SwiperSlide key={i}>
            <ServicesItemBlock item={item} image={getImageProps(item.titleAsImage, context)} />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* desktop */}

      <Container className='ServicesItemsBlock__items'>
        <div className='ServicesItemsBlock__items__wrapper'>
          {data.items.expandedValue.map((item: ServicesItemBlockData, i) => (
            <ServicesItemBlock key={i} item={item} image={getImageProps(item.titleAsImage, context)} />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default ServicesItemsBlock;
